export interface ISendErrorPayload {
  errorCode?: string;
  message?: string;
  // Already shown to the user (e.g. the global axios interceptor's own toast) — no second one.
  handled?: boolean;
}

export const extractSendErrorPayload = (err: unknown): ISendErrorPayload => {
  const body = (err as { response?: { data?: ISendErrorPayload } })?.response?.data;
  return { errorCode: body?.errorCode, message: body?.message };
};
